import type { GridFilterModel } from '@mui/x-data-grid';
import {
  buildTextSearchFilter,
  combineFilters,
  convertGridFilterToOData
} from '@utils/odata/filterBuilder';

type WorkOrderFilterOptions = {
  gridFilterModel?: GridFilterModel;
  searchText?: string;
};

const WORK_ORDER_SEARCHABLE_FIELDS = [
  'JobNumber',
  'CustomerName',
  'Description',
  'PurchaseOrderNumber',
  'BranchName'
];

const GRID_FIELD_MAPPING: Record<string, string> = {
  jobNumber: 'JobNumber',
  customerName: 'CustomerName',
  description: 'Description',
  status: 'Status',
  openDate: 'OpenDate',
  expectedDueDate: 'ExpectedDueDate',
  completionDate: 'CompletionDate',
  branchName: 'BranchName',
  employeeId: 'EmployeeId'
};

const buildGridFilter = (gridFilterModel?: GridFilterModel): string => {
  if (!gridFilterModel || !gridFilterModel.items?.length) {
    return '';
  }

  let filter = convertGridFilterToOData(gridFilterModel, GRID_FIELD_MAPPING);

  if (filter.includes('Status eq')) {
    filter = filter.replace(/Status eq '([^']+)'/g, (_match, value) => {
      const capitalizedValue =
        value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      return `Status eq IndySoft.EnterpriseApi.Domain.Enums.OrderStatus'${capitalizedValue}'`;
    });
  }

  return filter;
};

const buildSearchFilter = (searchText?: string): string => {
  if (!searchText?.trim()) {
    return '';
  }

  return buildTextSearchFilter(searchText.trim(), WORK_ORDER_SEARCHABLE_FIELDS);
};

export const buildWorkOrderODataFilter = (
  options: WorkOrderFilterOptions
): string => {
  const gridFilter = buildGridFilter(options.gridFilterModel);
  const searchFilter = buildSearchFilter(options.searchText);

  return combineFilters([gridFilter, searchFilter], 'and');
};
